import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../Translations';

interface Props {
  title: TPlainTextKey;
}

function CardTitle({ title }: Props) {
  return (
    <Typography
      as="div"
      variant="bodyMedium"
      fontWeight="semibold"
      color="dark"
      className="flex items-center mb-4 mt-7"
    >
      <T kind={title} />
    </Typography>
  );
}

export default observer(CardTitle);
